export const UPDATE_EVENT = 'actionId/UPDATE_EVENT'
export const UPDATE_EVENT_DARE = 'actionId/UPDATE_EVENT_DARE'
export const UPDATE_TERMS_ACCEPTED = 'UPDATE_TERMS_ACCEPTED'
